import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FAQ_SHORTCUT_GROUPS } from '../../data/faqData';
import './FaqShortcutCheatSheet.css';

export function FaqShortcutCheatSheet() {
  const { t } = useTranslation();

  if (FAQ_SHORTCUT_GROUPS.length === 0) {
    return null;
  }

  return (
    <section className="saas-faq-cheat" aria-labelledby="saas-faq-cheat-title">
      <div className="saas-faq-cheat__head">
        <h2 id="saas-faq-cheat-title" className="saas-faq-cheat__title">
          {t('faq.cheatSheetTitle')}
        </h2>
        <p className="saas-faq-cheat__sub">{t('faq.cheatSheetSub')}</p>
        <Link to="/faq?id=keyboard-shortcuts" className="saas-faq-cheat__more">
          {t('faq.cheatSheetMore')} →
        </Link>
      </div>
      <div className="saas-faq-cheat__grid">
        {FAQ_SHORTCUT_GROUPS.map((group) => (
          <div key={group.key} className="saas-faq-cheat__card">
            <h3 className="saas-faq-cheat__card-title">{t(group.titleKey)}</h3>
            <ul className="saas-faq-cheat__list">
              {group.items.map((item) => (
                <li key={`${group.key}-${item.chord}`} className="saas-faq-cheat__row">
                  <kbd className="saas-faq-cheat__chord">{item.chord}</kbd>
                  <span className="saas-faq-cheat__desc">{t(item.labelKey)}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
